import { loadAllOrganizations } from "../organizations/useAllOrganizations";

const getUserPermissions = async (
    keycloak_token: string,
): Promise<boolean> => {
    try {
        const orgs = await loadAllOrganizations(keycloak_token);
        return orgs.some(org => org.role === "admin" || org.role === "superuser");
    } catch (err: any) {
        console.log(err);
        return false;
    }
}

export default getUserPermissions;